import {ShopContainer} from "../ShopContainer";
import {removeRowOption, RowOptionCol} from "../../../logistics/purchasing/RowOptions";
import {GenericStatusCol, RenderStringCol, StringCol, Table} from "../../../../misc/scroller/Table";
import {FreeformChange} from "../../../../api/ProjectFreeformChange";
import {useProjectId} from "../ProjectName";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {useNavigate} from "react-router-dom";
import React from "react";
import {green, grey, orange} from "@mui/material/colors";

export function FreeformChanges() {

    const projectId = useProjectId();
    const tableName = `freeform-change-${projectId}`;
    const nav = useNavigate();

    return (<ShopContainer
        name="Changes"
        actions={<></>}
        overrideRightActions={<></>}
    >
        <Table<FreeformChange>
            name={tableName}
            columns={[
                RowOptionCol({
                    options: (dt) => [
                        dt.status === "draft" && removeRowOption(dt, {
                            refreshTables: [tableName],
                            confirm: true,
                        }),
                    ],
                }),
                RenderStringCol<FreeformChange>("Ref", v => v.id.toString(), 100),
                StringCol("Description", "description", 400),
                GenericStatusCol("Status", "status", {
                    "draft": {
                        display: "Draft",
                        color: green[200],
                    },
                    "submitted": {
                        display: "Submitted",
                        color: orange[200],
                    },
                    "completed": {
                        display: "Completed",
                        color: grey[200],
                    },
                }),
                GenericStatusCol("Finance", "financeStatus", {
                    "ok": {
                        display: "Ok",
                        color: green[200],
                    },
                    "needs-review": {
                        display: "Needs Review",
                        color: orange[200],
                    },
                    "pending-return": {
                        display: "Pending Return",
                        color: grey[200],
                    }
                })
            ]}
            onRowClick={input => {
                nav(`/project/${projectId}/shop-drawing/changes/ch/${input.id}`);
            }}
            fetch={ctx => getAll(ctx, offset => api.projectFreeformChange.list({offset, project: projectId}))}
            fetchDeps={[projectId]}
            onChange={input => api.projectFreeformChange.upsert(input)}
        />

    </ShopContainer>)
}